import { BookingProposalAccess } from '@components/BookingProposal/BookingProposalAccess';
import { Error404PageWithTranslations } from '@components/Error/Error404PageWithTranslations';
import { customerRoutes } from 'noddi-util';
import { Route, Routes } from 'react-router-dom';
import { BookingProposal } from './BookingProposal';
import { BookingProposalAddress } from './BookingProposal/Address';
import { ProposalBookingBuilder } from './BookingProposal/BookingBuilder';
import { BookingProposalConfirmation } from './BookingProposal/Confirmation';
import { BookingProposalLogin } from './BookingProposal/Login';
import { ProposalEditAddressPicker } from './BookingProposal/ProposalEditAddressPicker';
import { StationaryProposalLogin } from './BookingProposal/StationaryProposalLogin';
import { StationaryProposalSummary } from './BookingProposal/StationaryProposalSummary';
import { StationaryTimeWindowPicker } from './BookingProposal/StationaryTimeWindowPicker';
import { BookingProposalTimeWindowPicker } from './BookingProposal/TimeWindowPicker';

export function BookingProposalRouter() {
  return (
    // Inside RouterLayout, so a denied login keeps the header and brand background.
    <BookingProposalAccess>
      <Routes>
        <Route path={customerRoutes.bookingProposalLandingPage.getBasePath()} element={<BookingProposal />} />
        <Route path={customerRoutes.bookingProposalAddress.getBasePath()} element={<BookingProposalAddress />} />
        <Route path={customerRoutes.editProposalAddress.getBasePath()} element={<ProposalEditAddressPicker />} />
        <Route
          path={customerRoutes.bookingProposalTimeWindowPicker.getBasePath()}
          element={<BookingProposalTimeWindowPicker />}
        />
        <Route
          path={customerRoutes.stationaryProposalTimeWindow.getBasePath()}
          element={<StationaryTimeWindowPicker />}
        />
        <Route path={customerRoutes.stationaryProposalLogin.getBasePath()} element={<StationaryProposalLogin />} />
        <Route path={customerRoutes.stationaryProposalSummary.getBasePath()} element={<StationaryProposalSummary />} />
        {/* Legacy proposal paths — keep live SMS/email links working */}
        <Route path='/eontyre-time-window' element={<StationaryTimeWindowPicker />} />
        <Route path='/eontyre-summary' element={<StationaryProposalSummary />} />
        <Route path={customerRoutes.bookingProposalLogin.getBasePath()} element={<BookingProposalLogin />} />
        <Route
          path={customerRoutes.bookingProposalConfirmation.getBasePath()}
          element={<BookingProposalConfirmation />}
        />
        <Route path={customerRoutes.bookingProposalBuilding.getBasePath()} element={<ProposalBookingBuilder />} />
        <Route path='*' element={<Error404PageWithTranslations />} />
      </Routes>
    </BookingProposalAccess>
  );
}
